export var camelCaseConvertor = function (str) {
    return str
        .replace('_', ' ')
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
        .replace(/\s+/g, '');
};
export var makeObjectData = function (objectData) {
    var auxObjectData = {};
    Object.keys(objectData).forEach(function (key) {
        var newKey = camelCaseConvertor(key);
        auxObjectData[newKey] = objectData[key];
    });
    return auxObjectData;
};
export var getLastNumberOfString = function (str) {
    var allNumbers = str
        .replace(/[^0-9]/g, ' ')
        .trim()
        .split(/\s+/);
    return parseInt(allNumbers[allNumbers.length - 1], 10) ? parseInt(allNumbers[allNumbers.length - 1], 10) : undefined;
};
//# sourceMappingURL=utils.js.map